<template>
  <div class="vb088">

    <!-- Hero -->
    <header class="vb088__hero">
      <div class="vb088__hero-bg"></div>
      <div class="vb088__hero-overlay"></div>
      <div class="vb088__hero-glow"></div>

      <div class="vb088__hero-inner">
        <div class="vb088__hero-badge">
          <span class="vb088__hero-badge-dot">
            <span class="vb088__hero-badge-ping"></span>
          </span>
          {{ $t('blog.vantagebonus.badge') }}
        </div>

        <h1 class="vb088__hero-title" v-html="$t('blog.vantagebonus.heroTitle')"></h1>
        <p class="vb088__hero-subline">{{ $t('blog.vantagebonus.heroSubline') }}</p>
        <p class="vb088__hero-lead" v-html="$t('blog.vantagebonus.heroLead')"></p>

        <div class="vb088__hero-deadline">
          <i class="fas fa-clock"></i>
          {{ $t('blog.vantagebonus.heroDeadline') }} <strong>{{ $t('blog.vantagebonus.heroDeadlinePeriod') }}</strong>
        </div>

        <div class="vb088__hero-actions">
          <a
            href="#vb088-open-account"
            class="vb088__hero-btn vb088__hero-btn--primary"
          >
            <i class="fas fa-user-plus"></i>
            {{ $t('blog.vantagebonus.openBtn') }}
          </a>
          <a href="#details" class="vb088__hero-btn vb088__hero-btn--ghost">
            <i class="fas fa-arrow-down"></i>
            {{ $t('blog.vantagebonus.heroBtn') }}
          </a>
        </div>

        <div class="vb088__hero-slider" aria-hidden="true">
          <div class="vb088__hero-slider-track">
            <span v-for="(h, i) in [...highlights, ...highlights]" :key="`vb088-slide-${i}`">
              <i :class="h.icon"></i>
              {{ h.value }} · {{ h.label }}
            </span>
          </div>
        </div>
      </div>

      <div class="vb088__hero-wave">
        <svg viewBox="0 0 1440 80" fill="none" preserveAspectRatio="none">
          <path d="M0 80L60 65C120 50 240 20 360 10C480 0 600 0 720 7.5C840 15 960 30 1080 37.5C1200 45 1320 45 1380 45L1440 45V80H0Z" fill="#f5f3ff"/>
        </svg>
      </div>
    </header>

    <!-- Highlights -->
    <section id="details" class="vb088__section vb088__section--light">
      <div class="vb088__shell">
        <div class="vb088__section-header">
          <div class="vb088__section-eyebrow">0.88% Daily Bonus</div>
          <h2 class="vb088__section-title">{{ $t('blog.vantagebonus.bonusVantage') }}</h2>
          <div class="vb088__divider"></div>
        </div>

        <div class="vb088__highlights">
          <div
            v-for="(h, i) in highlights"
            :key="i"
            class="vb088__highlight-card"
          >
            <div class="vb088__highlight-icon">
              <i :class="h.icon"></i>
            </div>
            <div class="vb088__highlight-value">{{ h.value }}</div>
            <div class="vb088__highlight-label">{{ h.label }}</div>
          </div>
        </div>
      </div>
    </section>

    <!-- Điều kiện tham gia -->
    <section class="vb088__section vb088__section--white">
      <div class="vb088__shell">
        <div class="vb088__section-header">
          <h2 class="vb088__section-title">{{ $t('blog.vantagebonus.joinTitle') }}</h2>
          <div class="vb088__divider"></div>
        </div>

        <div class="vb088__conditions">
          <div
            v-for="(cond, i) in joinConditions"
            :key="i"
            class="vb088__condition-item"
          >
            <div class="vb088__condition-icon">
              <i :class="cond.icon"></i>
            </div>
            <p class="vb088__condition-text">{{ cond.text }}</p>
          </div>
        </div>
      </div>
    </section>

    <!-- Điều kiện tính thưởng -->
    <section class="vb088__section vb088__section--light">
      <div class="vb088__shell">
        <div class="vb088__section-header">
          <h2 class="vb088__section-title">{{ $t('blog.vantagebonus.rewardTitle') }}</h2>
          <div class="vb088__divider"></div>
        </div>

        <div class="vb088__conditions">
          <div
            v-for="(cond, i) in rewardConditions"
            :key="i"
            class="vb088__condition-item"
          >
            <div class="vb088__condition-icon">
              <i :class="cond.icon"></i>
            </div>
            <p class="vb088__condition-text">{{ cond.text }}</p>
          </div>
        </div>
      </div>
    </section>

    <!-- Ảnh hướng dẫn -->
    <section class="vb088__section vb088__section--white">
      <div class="vb088__shell">
        <div class="vb088__section-header">
          <h2 class="vb088__section-title">{{ $t('blog.vantagebonus.imageTitle') }}</h2>
          <div class="vb088__divider"></div>
        </div>

        <div class="vb088__image-wrap" @click="openImageModal">
          <img
            src="https://songhancapital.com/assets/image/vantage_bonus.jpg"
            :alt="$t('blog.vantagebonus.imageAlt')"
          />
          <div class="vb088__image-caption">
            <i class="fas fa-search-plus"></i>
            {{ $t('blog.vantagebonus.imageCaption') }}
          </div>
        </div>
      </div>
    </section>

    <!-- Lưu ý quan trọng -->
    <section class="vb088__section vb088__section--light">
      <div class="vb088__shell">
        <div class="vb088__section-header">
          <h2 class="vb088__section-title">{{ $t('blog.vantagebonus.warnTitle') }}</h2>
          <div class="vb088__divider"></div>
        </div>

        <div class="vb088__warnings">
          <div
            v-for="(warn, i) in warnings"
            :key="i"
            class="vb088__warning-item"
          >
            <i :class="warn.icon"></i>
            <p>{{ warn.text }}</p>
          </div>
        </div>
      </div>
    </section>

    <!-- Mở tài khoản -->
    <section id="vb088-open-account" class="vb088__section vb088__section--white">
      <div class="vb088__shell">
        <div class="vb088__section-header">
          <h2 class="vb088__section-title">{{ $t('blog.vantagebonus.openAccountTitle') }}</h2>
          <p class="vb088__section-sub">{{ $t('blog.vantagebonus.openAccountSub') }}</p>
          <div class="vb088__divider"></div>
        </div>

        <div class="vb088__broker-card">
          <div class="vb088__broker-logo">Vantage</div>
          <h3 class="vb088__broker-title">{{ $t('blog.vantagebonus.openAccountTitle') }}</h3>

          <div class="vb088__broker-info">
            <div class="vb088__broker-row">
              <span class="vb088__broker-label">{{ $t('blog.vantagebonus.linkLabel') }}</span>
              <a
                href="https://vigco.co/la-com/vi/SHCcapital"
                target="_blank"
                rel="noopener noreferrer"
                class="vb088__broker-link"
              >
                vigco.co/SHCcapital <i class="fas fa-external-link-alt"></i>
              </a>
            </div>
            <div class="vb088__broker-row">
              <span class="vb088__broker-label">{{ $t('blog.vantagebonus.codeLabel') }}</span>
              <div class="vb088__broker-code-wrap">
                <span class="vb088__broker-code" @click="copyCode('SHCcapital')">
                  SHCcapital <i class="fas fa-copy"></i>
                </span>
                <button class="vb088__guide-btn" @click="openGuideModal">
                  <i class="fas fa-images"></i>
                  {{ $t('blog.vantagebonus.guideBtn') }}
                </button>
              </div>
            </div>
          </div>

          <a
            href="https://vigco.co/la-com/vi/SHCcapital"
            target="_blank"
            rel="noopener noreferrer"
            class="vb088__broker-btn"
          >
            <i class="fas fa-user-plus"></i>
            {{ $t('blog.vantagebonus.openBtn') }}
          </a>
          <p class="vb088__broker-note">{{ $t('blog.vantagebonus.brokerNote') }}</p>

        </div>

        <!-- CTA -->
        <div class="vb088__cta">
          <p>{{ $t('blog.vantagebonus.ctaText') }}</p>
          <button class="vb088__cta-btn" @click="goToContact">
            <i class="fas fa-comments"></i>
            {{ $t('blog.vantagebonus.ctaBtn') }}
          </button>
          <p class="vb088__disclaimer">{{ $t('blog.vantagebonus.disclaimer') }}</p>
        </div>
      </div>
    </section>

    <!-- Copy toast -->
    <div v-if="showCopyToast" class="vb088__toast">
      <i class="fas fa-check-circle"></i> {{ $t('blog.vantagebonus.toastMsg') }}
    </div>

    <!-- Image modal (ảnh hướng dẫn đăng ký bonus) -->
    <div v-if="showImageModal" class="vb088__modal" @click="closeImageModal">
      <div class="vb088__modal-box" @click.stop>
        <button class="vb088__modal-close" @click="closeImageModal">
          <i class="fas fa-times"></i>
        </button>
        <p class="vb088__modal-caption">{{ $t('blog.vantagebonus.modalCaption') }}</p>
        <img
          src="https://songhancapital.com/assets/image/vantage_bonus.jpg"
          :alt="$t('blog.vantagebonus.imageAlt')"
          class="vb088__modal-img"
        />
      </div>
    </div>

    <!-- Guide modal (ảnh hướng dẫn nhập mã đối tác) -->
    <div v-if="showGuideModal" class="vb088__modal" @click="closeGuideModal">
      <div class="vb088__modal-box" @click.stop>
        <button class="vb088__modal-close" @click="closeGuideModal">
          <i class="fas fa-times"></i>
        </button>
        <p class="vb088__modal-caption">{{ $t('blog.vantagebonus.guideImgAlt') }}</p>
        <img
          src="https://songhancapital.com/assets/image/open_vantage.jpg"
          :alt="$t('blog.vantagebonus.guideImgAlt')"
          class="vb088__modal-img"
        />
      </div>
    </div>

  </div>
</template>

<script src="./vantage-bonus-088.js"></script>
<style src="./vantage-bonus-088.scss" lang="scss"></style>
